// extracted by mini-css-extract-plugin
module.exports = {"customInput":"FilterModal2_customInput__2vUu-","inputS":"FilterModal2_inputS__20Auf"};